module.exports = __webpack_public_path__ + "img/united-kingdom.35d9cbf4.svg";